var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Signal from "@/utils/signals/Signal";
var EventBus = (function () {
    function EventBus() {
        this.signal = new Signal();
    }
    EventBus.prototype.on = function (name, handler, priority, once) {
        if (priority === void 0) { priority = 0; }
        if (once === void 0) { once = false; }
        this.signal.on(name, handler, priority, once);
    };
    EventBus.prototype.off = function (name, handler) {
        this.signal.off(name, handler);
    };
    EventBus.prototype.emit = function (name) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        (_a = this.signal).emit.apply(_a, __spreadArray([name], args, false));
    };
    return EventBus;
}());
export default EventBus;



//////////////////
// WEBPACK FOOTER
// ./src/modules/eventbus/models/EventBus.ts
// module id = null
// module chunks = 